import React, { Component } from 'react'
import PopupWindow from './PopupWindow'
import { connect } from 'react-redux';
import * as StatisticActions from '../../actions/statisticActions';
import { bindActionCreators } from 'redux';
import Checkbox from './Checkbox'
import StatsBaseWindow from './StatsBaseWindow'
import { SET_THEME } from '../../actions/gameActions'

class SettingsWindow extends StatsBaseWindow {

  constructor(props) {
    super(props);

    this.SettingsWindowPosition = {top: 100, left: 350};
  }

  calculateSettingsWindowPosition(){
    var button = document.getElementById("settings_button");
    var pos = getCoords(button);
    this.SettingsWindowPosition = {top: pos.top+35, left: pos.left - 230};
  }

  componentDidMount() {   
    var gui = new window.dat.GUI({ autoPlace: false });
    var PitchSettings = window.PitchSettings;
    var SoundSettings = window.SoundSettings;
    var TextSettings = window.TextSettings;
    var ModalSettings = window.ModalSettings;
    gui.useLocalStorage = true;  
    gui.width = 300;
    gui.remember(PitchSettings);
    gui.remember(SoundSettings); 
    gui.remember(TextSettings); 
    gui.remember(ModalSettings); 

    gui.closed = false;

    var f1 = gui.addFolder('Поле');
    f1.add(PitchSettings, 'ShowReferee').name('Гл. Судья (бета)');
    f1.add(PitchSettings, 'ShowGoalReplays').name('Повторы голов');
    f1.add(PitchSettings, 'ReplaySpeed', 20, 60).name('Скорость повторов');
    f1.add(PitchSettings, 'DefaultColors').name('Запасные цвета');
    f1.add(PitchSettings, 'PlayerNames', { "Кто рядом с мячом": 0, "Всех": 1, "Только хозяев": 2, "Только гостей": 3, "Не показывать" :4 }).name('Имена игроков');
    f1.add(PitchSettings, 'ShowPlayerFatigue').name('Индикатор усталости');

    var f2 = gui.addFolder('Звук');
    f2.add(SoundSettings, 'Volume', 0, 100).name('Громкость').onChange(value => {
        this.updateSoundControl(value, SoundSettings.NoiseVolume);
    });
    f2.add(SoundSettings, 'NoiseVolume', 0, 100).name('Шум стадиона').onChange(value => {
        this.updateSoundControl(SoundSettings.Volume, value);
    });
    f2.add(SoundSettings, 'ShortPassAnimation').name('Короткий пас');

    var f3 = gui.addFolder('Текст');
    f3.add(TextSettings, 'ShowText').name('Показывать');
    f3.add(TextSettings, 'UseTeamColors').name('Цвета команд');

    var f4 = gui.addFolder('Статистика');
    f4.add(ModalSettings, 'Theme', { "Классическая": 0, "Черно-белая": 1 }).name('Тема').onChange(value => {
        this.updateTheme(value);
    });
    f4.add(ModalSettings, 'ShowStartingLineup').name('Стартовые составы');

    this.updateTheme(ModalSettings.Theme);

    var customContainer = document.getElementById('settings_container');
    customContainer.appendChild(gui.domElement);

    window.addEventListener("resize", ()=> {
        this.calculateSettingsWindowPosition();
        this.forceUpdate();
    });

    this.calculateSettingsWindowPosition();
    this.forceUpdate();

    this.updateSoundControl(SoundSettings.Volume, SoundSettings.NoiseVolume);
  }

  updateSoundControl(volume, noiseVolume) {
    if(window.onSoundChange != null)
        window.onSoundChange(volume, noiseVolume);
  }

  updateTheme(themeId) {
    var cssId = 'black-white'; 
    this.props.dispatch(SET_THEME(parseInt(themeId)));
    if(themeId == 1) {
        if (!document.getElementById(cssId))
        {
            var head  = document.getElementsByTagName('head')[0];
            var link  = document.createElement('link');
            link.id   = cssId;
            link.rel  = 'stylesheet';
            link.type = 'text/css';
            link.href = './black.theme.css';
            link.media = 'all';
            head.appendChild(link);
        }
      }
      else {
        let css = document.getElementById(cssId)
        if (css) {
            css.parentElement.removeChild(css);
        }
      }
  }

  render() {        
        return (<PopupWindow hidden={!this.props.visible} header={'Настройки'} show_header={false} width={310} show_close={false} draggable={false} show_cut_down={false} top={this.SettingsWindowPosition.top}  left={this.SettingsWindowPosition.left}>
                    <div id='settings_container'></div>
                </PopupWindow>)
    }
}

function mapStateToProps(state, ownProps) {
    return {
      visible: state.showSettings
    };
}

function getCoords(elem) { // crossbrowser version
    var box = elem.getBoundingClientRect();

    var body = document.body;
    var docEl = document.documentElement;

    var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

    var clientTop = docEl.clientTop || body.clientTop || 0;
    var clientLeft = docEl.clientLeft || body.clientLeft || 0;

    var top  = box.top +  scrollTop - clientTop;
    var left = box.left + scrollLeft - clientLeft;

    return { top: Math.round(top), left: Math.round(left) };
}

export default connect(mapStateToProps)(SettingsWindow)



/** WEBPACK FOOTER **
 ** ./src/components/PopupStats/SettingsWindow.js
 **/